import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"
import menuMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Sala de Juntas',
            tblTitle: 'Lista de Salas de {locationName}',
            tblbutton: 'Nueva Sala',
            mdlSave: 'Guardar',
            mdlCancel: 'Cancelar',
            lblName: "Nombre",
            lblDescription: "Descripcion",
            dlgUploadTitle: "Editar sala de juntas",

            headerId: 'Id',
            headerName: 'Nombre',
            headerLocation: 'Localidad',
            headerComments: 'Descripcion',
            headerEstado: 'Estado',
            headerAction: 'Acciones',

            lblSearch: 'Buscar',
            lblQR: 'Código QR',
            lblEdit: 'Editar',
            lblImage: 'Galería de imágenes',
            lblAttribe: 'Atributos de salas',
            lblback: 'Atras',
            lblClose: 'Cerrar',

        },
        en: {
            moduleTitle: 'Meeting Rooms',
            tblTitle: "{locationName}'s meeting List",
            tblbutton: 'New Meeting',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',
            lblName: "Name",
            lblDescription: "Comments",
            dlgUploadTitle: "Edit meeting list",

            headerId: 'Id',
            headerName: 'Name',
            headerLocation: 'Location',
            headerComments: 'Comments',
            headerEstado: 'Status',
            headerAction: 'Actions',

            lblSearch: 'Search',
            lblQR: 'QR Code',
            lblEdit: 'Edit',
            lblImage: 'Image gallery',
            lblAttribe: 'Room attributes',
            lblback: 'Go back',
            lblClose: 'Close',

        }
    }
}

export default _.merge(messages, defaultMessages, menuMessages)